const addiesaas = window.addiesaas || (window.addiesaas = {})
const EventBus = window.VueEventBus
import vuestrap from '../../vuestrap'

export default {addiesaas, Vue, vuestrap, EventBus}
